import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { ContentSeparator } from './ContentSeparator.styled'

export const ContentSeparatorRegistration = createRegisterableComponent(
    'content-separator',
    (props, _services) => <ContentSeparator {...props} />,
)
